<template>
  <div class="download-box">
    <div class="download-container">
      <div class="title-container">
        <div style="text-align: center" class="reveal-bottom">
          <span class="title-icon"></span>
          <div class="title-name">{{ $t("m100.download_m100") }}</div>
          <div :class="lang === 'en_US' ? 'title-desc-en' : 'title-desc'">
            {{ $t("m100.download_tip") }}
          </div>
          <div class="title-btn">
            <div
              class="btn-container"
              style="margin-right: 24px"
              @click="getDownload"
            >
              {{ $t("m100.c5") }}
            </div>

            <div
              class="btn-container btn2"
              style="margin-right: 24px"
              @click="getIPSC"
              v-if="platform === 'windows' || platform === 'mac'"
            >
              {{ $t("m100.download_ipsec") }}
            </div>
          </div>
          <div :class="lang === 'en_US' ? 'clinet-bg-en' : 'clinet-bg'"></div>
        </div>
      </div>
    </div>

    <div class="download-content reveal-bottom">
      <div style="display: flex">
        <!-- IOS -->
        <div class="content-box">
          <div style="margin-bottom: 16px">
            <span class="content-icon ios-icon"></span
            ><span class="content-name">IOS</span>
          </div>
          <DownloadQrLink
            href="https://apps.apple.com/us/app/obc-m100/id1513866218"
          >
            <a
              class="content-info ios-content-info"
              href="https://apps.apple.com/us/app/obc-m100/id1513866218"
              target="_blank"
              rel="noopener noreferrer"
              v-html="iosDownloadTextHtml"
            ></a>
          </DownloadQrLink>
        </div>
        <!-- Android -->
        <div class="content-box">
          <div style="margin-bottom: 16px">
            <span class="content-icon android-icon"></span
            ><span class="content-name">Android</span>
          </div>
          <div>
            <DownloadQrLink :href="android && android.url">
              <a
                class="content-download-a"
                :href="android && android.url"
                :download="android && android.name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="content-tips">{{ $t("m100.download") }}</span>
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
        <!-- Mac -->
        <div class="content-box">
          <div style="margin-bottom: 16px">
            <span class="content-icon mac-icon"></span
            ><span class="content-name">Mac</span>
          </div>
          <div class="content-download" style="margin-bottom: 16px">
            <DownloadQrLink :href="macSSL && macSSL.url">
              <a
                class="content-download-a"
                :href="macSSL && macSSL.url"
                :download="macSSL && macSSL.name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="content-tips">{{ $t("m100.download") }}</span>
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
          <div class="content-download">
            <DownloadQrLink :href="mac && mac.url">
              <a
                class="content-download-a"
                :href="mac && mac.url"
                :download="mac && mac.name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="content-tips"
                  >{{ $t("m100.download") }} (IPSec)</span
                >
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
      </div>

      <div style="display: flex">
        <!-- Windows -->
        <div class="content-box" style="border-bottom: none">
          <div style="margin-bottom: 16px">
            <span class="content-icon window-icon"></span
            ><span class="content-name">Windows</span>
          </div>
          <div class="content-download" style="margin-bottom: 16px">
            <DownloadQrLink :href="windowsSSL && windowsSSL.url">
              <a
                class="content-download-a"
                :href="windowsSSL && windowsSSL.url"
                :download="windowsSSL && windowsSSL.name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="content-tips">{{ $t("m100.download") }}</span>
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
          <div class="content-download">
            <DownloadQrLink :href="windows && windows.url">
              <a
                class="content-download-a"
                :href="windows && windows.url"
                :download="windows && windows.name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="content-tips"
                  >{{ $t("m100.download") }} (IPSec)</span
                >
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
        <!-- 麒麟/统信 -->
        <div class="content-box" style="border-bottom: none">
          <div style="margin-bottom: 16px">
            <span class="content-icon deb-icon"></span
            ><span class="content-name">{{ $t("m100.download_kylin") }}</span>
          </div>
          <div class="content-download" style="margin-bottom: 16px">
            <DownloadQrLink :href="debArm64 && debArm64.url">
              <a
                class="content-download-a"
                href="javascript:void(0)"
                @click.prevent="openKylinInstallTip(debArm64, 'Arm64')"
              >
                <span class="content-tips"
                  >{{ $t("m100.download") }} (Arm64)</span
                >
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
          <div class="content-download">
            <DownloadQrLink :href="debx64 && debx64.url">
              <a
                class="content-download-a"
                href="javascript:void(0)"
                @click.prevent="openKylinInstallTip(debx64, 'X64')"
              >
                <span class="content-tips"
                  >{{ $t("m100.download") }} (X64)</span
                >
                <span class="content-arrow"></span>
              </a>
            </DownloadQrLink>
          </div>
        </div>
        <!-- HarmonyOS -->
        <div class="content-box" style="border: none">
          <div style="margin-bottom: 16px">
            <span class="content-icon harmonyOS-icon"></span
            ><span class="content-name">HarmonyOS NEXT</span>
          </div>
          <!-- <div class="content-info">{{ $t("m100.c8") }}</div> -->
          <DownloadQrLink
            href="https://appgallery.huawei.com/app/detail?id=com.oceanbluecloud.hongantong"
          >
            <a
              class="content-info ios-content-info"
              href="https://appgallery.huawei.com/app/detail?id=com.oceanbluecloud.hongantong"
              target="_blank"
              rel="noopener noreferrer"
              v-html="harmonyOSDownloadTextHtml"
            ></a>
          </DownloadQrLink>
        </div>
      </div>
    </div>

    <KylinInstallTip
      :visible="kylinTipVisible"
      :package-data="kylinPackageData"
      :download-label="kylinDownloadLabel"
      @close="closeKylinInstallTip"
    />
  </div>
</template>
<script>
import initAnimation from "../animation";
import axios from "@/http";
import DownloadQrLink from "@/components/DownloadQrLink.vue";
import KylinInstallTip from "@/components/KylinInstallTip.vue";
export default {
  components: {
    DownloadQrLink,
    KylinInstallTip,
  },
  data() {
    return {
      android: null,
      mac: null,
      macSSL: null,
      windows: null,
      windowsSSL: null,
      debArm64: null,
      debx64: null,
      lang: localStorage.getItem("lang"),
      platform: null,
      kylinTipVisible: false,
      kylinPackageData: null,
      kylinDownloadLabel: "",
    };
  },
  mounted() {
    setTimeout(initAnimation, 0);
    this.$bus.$on("lang", (lang) => {
      this.lang = lang;
    });
  },
  created() {
    this.getData();
    this.getPlatform();
  },
  computed: {
    iosDownloadTextHtml() {
      const text = this.$t("m100.c4");
      if (this.lang === "en_US") {
        return text.replace(
          /M100/g,
          '<span style="color: #00a3d1;font-size:20px;vertical-align: top;">M100</span>'
        );
      }
      return text.replace(
        /睿连终端M100/g,
        '<span style="color: #00a3d1;;font-size:20px;vertical-align: top;">睿连终端M100</span>'
      );
    },
    harmonyOSDownloadTextHtml() {
      const text = this.$t("m100.c8");
      return text.replace(
        /鸿安通/g,
        '<span style="color: #00a3d1;font-size:20px;vertical-align: top;">鸿安通</span>'
      );
    },
  },
  methods: {
    back: function () {
      this.$router.back();
    },
    getData: async function () {
      const res = await axios.get("/api2/client/side/latest");
      if (res.code === 0) {
        this.android = res.data.ANDROID;
        this.mac = res.data.MAC;
        this.macSSL = res.data.MAC_SSL;
        this.windows = res.data.WIN;
        this.windowsSSL = res.data.WIN_SSL;
        this.debArm64 = res.data.LINUX_ARM64;
        this.debx64 = res.data.LINUX_AMD64;
      }
      console.log(res);
    },
    getDownload() {
      const pkg = this.getOS();
      console.log(pkg);
      if (!pkg || !pkg.url) {
        return;
      }

      // 麒麟/统信（Linux deb）与下方下载区一致：先弹窗提示，再在弹窗内下载
      if (pkg === this.debArm64) {
        this.openKylinInstallTip(this.debArm64, "Arm64");
        return;
      }
      if (pkg === this.debx64) {
        this.openKylinInstallTip(this.debx64, "X64");
        return;
      }

      const link = document.createElement("a");
      link.href = pkg.url;
      link.download = pkg.name;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getPlatform() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.includes("windows")) {
        this.platform = "windows";
        return;
      }

      if (ua.includes("mac os x")) {
        this.platform = "mac";
        return;
      }

      if (ua.includes("linux") && ua.includes("x86_64")) {
        this.platform = "debX64";
        return;
      }

      if (ua.includes("linux") && ua.includes("arm64")) {
        this.platform = "debArm64";
        return;
      }
      this.platform = null;
      return;
    },
    getIPSC() {
      let data = null;
      if (this.platform === "windows") {
        data = this.windows;
      } else if (this.platform === "mac") {
        data = this.mac;
      }
      if (data) {
        const fileUrl = data.url; // 你实际的文件地址
        const fileName = data.name; // 下载后的文件名
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    openKylinInstallTip(packageData, downloadLabel) {
      if (!packageData || !packageData.url) {
        return;
      }
      this.kylinPackageData = packageData;
      this.kylinDownloadLabel = downloadLabel;
      this.kylinTipVisible = true;
    },
    closeKylinInstallTip() {
      this.kylinTipVisible = false;
      this.kylinPackageData = null;
      this.kylinDownloadLabel = "";
    },
    getOS() {
      const ua = navigator.userAgent.toLowerCase();
      const platform = navigator.platform.toLowerCase();
      console.log(ua);
      console.log(platform);
      if (ua.includes("windows")) {
        return this.windowsSSL;
      }

      if (ua.includes("mac os x")) {
        return this.macSSL;
      }

      if (ua.includes("linux") && ua.includes("x86_64")) {
        console.log("进来了x86_64");
        return this.debx64;
      }

      if (ua.includes("linux") && ua.includes("arm64")) {
        console.log("进来了arm64");
        return this.debArm64;
      }

      return null;
    },
  },
};
</script>
<style scoped>
.download-container {
  width: 100%;
  height: 844px;
  background-image: url("../../assets/images/download/download-bg.png");
  background-size: cover;
  padding-top: 100px;
  box-sizing: border-box;
}
.title-container {
  width: 1200px;
  margin: 0 auto;
}
.title-icon {
  display: inline-block;
  width: 68px;
  height: 68px;
  background-image: url("../../assets/images/download/m100.png");
  background-size: cover;
  margin-bottom: 24px;
}
.title-name {
  height: 42px;
  line-height: 42px;
  font-weight: 500;
  font-size: 30px;
  color: #222222;
  font-style: normal;
  text-transform: none;
  margin-bottom: 24px;
}
.title-desc {
  width: 654px;
  font-weight: 400;
  font-size: 24px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
  line-height: 1.5;
  margin-bottom: 48px;
}
.title-desc-en {
  width: 1200px;
  font-weight: 400;
  font-size: 24px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
  line-height: 1.5;
  margin-bottom: 48px;
}
.title-btn {
  margin-bottom: 44px;
}
.btn-container {
  display: inline-block;
  width: 164px;
  height: 50px;
  line-height: 50px;
  background: #00a3d1;
  border-radius: 0px 0px 0px 0px;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}
.btn2 {
  background: transparent;
  border: 1px solid #00a3d1;
  font-weight: 400;
  font-size: 20px;
  color: #00a3d1;
  font-style: normal;
  text-transform: none;
}
.clinet-bg {
  display: inline-block;
  width: 776px;
  height: 370px;
  margin: 0 auto;
  background-image: url("../../assets/images/download/m100-bg.png");
  background-size: cover;
}
.clinet-bg-en {
  display: inline-block;
  width: 776px;
  height: 370px;
  margin: 0 auto;
  background-image: url("../../assets/images/download/m100-bg-en.png");
  background-size: cover;
}
.download-content {
  width: 1200px;
  padding: 60px 120px;
  margin: 0 auto;
}
.content-download-a {
  display: inline-block;
}
.content-box {
  flex: 1;
  height: 172px;
  padding-left: 24px;
  padding-top: 24px;
  box-sizing: border-box;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.content-box:first-child {
  padding-left: 0px;
}
.content-box:last-child {
  border-right: none;
}
.content-icon {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 16px;
}
.content-name {
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.ios-icon {
  background-image: url("../../assets/images/download/ios.png");
  background-size: cover;
}
.android-icon {
  background-image: url("../../assets/images/download/android.png");
  background-size: cover;
}
.mac-icon {
  background-image: url("../../assets/images/download/mac.png");
  background-size: cover;
}
.window-icon {
  background-image: url("../../assets/images/download/window.png");
  background-size: cover;
}
.deb-icon {
  background-image: url("../../assets/images/download/deb.png");
  background-size: cover;
}
.harmonyOS-icon {
  background-image: url("../../assets/images/download/HarmonyOS.png");
  background-size: cover;
}
.content-info {
  height: 28px;
  font-weight: 400;
  font-size: 20px;
  color: #909090;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 1.5;
}
.ios-content-info {
  display: inline-block;
  text-decoration: none;
  cursor: pointer;
}
.content-tips {
  height: 28px;
  line-height: 28px;
  font-weight: 400;
  font-size: 20px;
  color: #00a3d1;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-right: 8px;
  cursor: pointer;
}
.content-arrow {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url("../../assets/images/download/d-arrow.png");
  background-size: cover;
  vertical-align: top;
  margin-top: 4px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/Pages/Download/DownloadM100.vue